import { render, staticRenderFns } from "./organPopper.vue?vue&type=template&id=4bce7910&scoped=true&"
import script from "./organPopper.vue?vue&type=script&lang=js&"
export * from "./organPopper.vue?vue&type=script&lang=js&"
import style0 from "./organPopper.vue?vue&type=style&index=0&id=4bce7910&prod&lang=scss&scoped=true&"
import style1 from "./organPopper.vue?vue&type=style&index=1&id=4bce7910&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bce7910",
  null
  
)

export default component.exports